
import { defineComponent, ref, watch } from "vue";
import { trans } from "@/globals/translator";
import { formatDateLong } from "@/utils/dateTimeFormatter";
import ImagePoster from "@/components/common/ImagePoster.vue";
import Label from "@moonlight/vue3/components/Label.vue";

const ONE_YEAR_IN_MS = 365 * 24 * 60 * 60 * 1000;

export default defineComponent({
  components: {
    ImagePoster,
    Label,
  },
  props: {
    to: { type: [String, Object], required: true },
    image: { type: String, required: true },
    title: { type: String, required: true },
    date: { type: Date, required: true },
    type: { type: String, required: false },
    mediaId: { type: Number },
  },
  setup(props) {
    const dateFormatted = ref("...");

    watch(
      () => props.date,
      async () => {
        if (props.date.getTime() > Date.now() + ONE_YEAR_IN_MS) {
          dateFormatted.value = trans("general.coming_soon") || "";
        } else {
          dateFormatted.value = formatDateLong(props.date.getTime() / 1000);
        }
      },
      { immediate: true }
    );

    return {
      dateFormatted,
      trans,
    };
  },
});
